import { Box, Button, Typography, Alert } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useHandleApiResponse from '../../../../../Hooks/useHandleApiResponse';
import { useSelector } from 'react-redux';
import { getLensSyncData } from '../../../../../redux/features/lensSyncSlice';
import { allUserSync } from '../../../../../redux/features/lensSyncSlice';

export default function ConfirmAllSyncModal({ row, onClose }) {
  const dispatch = useDispatch();
  const handleApiResponse = useHandleApiResponse();

  const { loading } = useSelector((state) => state.lens);

  const [confirmed, setConfirmed] = React.useState(false);

  const handleConfirm = () => {
    setConfirmed(true);
  };

  const handleAllSync = async () => {
    const payload = {
      admnNo: row?.admn_no, // make sure this exists in row
    };

    dispatch(allUserSync(payload)).then((res) => {
      handleApiResponse(res, {
        onSuccess: () => {
          onClose();
        },
        onFailed: () => {
          console.log('All Sync Failed');
        },
      });
    });
  };
  if (!row) return null;

  const student_synced = Boolean(row?.wise_student_id);
  const course_synced = Boolean(row?.wise_course_classroom_id);
  const tutor_synced = Boolean(row?.wise_teacher_id);

  return (
    <Box p={3}>
      <Typography fontWeight={600} mb={2}>
        Student: {row.student_name}
      </Typography>

      {!confirmed ? (
        <Alert severity="info" sx={{ mb: 2 }}>
          <strong>Disclaimer</strong>
          <br />
          "All Sync" will check and sync:
          <br />
          ✔ Students ✔ Courses ✔ Tutors
          <br />
          <strong>Missing records will be created</strong>
          <br />
          <strong>Existing records will be updated</strong>
        </Alert>
      ) : (
        <Box mb={2}>
          <Alert severity={student_synced ? 'success' : 'warning'}>
            {student_synced ? '✅ Student already synced' : '❌ Student is not synced'}
          </Alert>

          <Alert severity={course_synced ? 'success' : 'warning'}>
            {course_synced ? '✅ Course already synced' : '❌ Course is not synced'}
          </Alert>

          <Alert severity={tutor_synced ? 'success' : 'warning'}>
            {tutor_synced ? '✅ Tutor already synced' : '❌ Tutor is not synced'}
          </Alert>
        </Box>
      )}

      <Box display="flex" justifyContent="flex-end" gap={2}>
        <Button onClick={() => onClose(false)}>Cancel</Button>
        <Button variant="contained" onClick={!confirmed ? handleConfirm : handleAllSync} disabled={loading}>
          {confirmed ? 'Confirm' : 'Continue'}
        </Button>
      </Box>
    </Box>
  );
}
